import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import { PAX_FORM_PLACEHOLDER, getLetterFromIndex } from '../../commons/utils';

import SelectorInput from '../SelectorInput';

const PaxForm = (props) => {
  const { pax, readOnly, hasToValidate } = props;

  const { id, name, surnames } = pax;

  const cehckValidation = (value) => {
    if (hasToValidate) return (value !== '');

    return true;
  };

  const handlePaxName = (value) => {
    props.handlePaxData({ id, name: value });
  };

  const handlePaxSurname = (value) => {
    props.handlePaxData({ id, surnames: value });
  };

  const customPlaceHolder = `${PAX_FORM_PLACEHOLDER} ${getLetterFromIndex(id - 1)}`;

  return (
    <Row className="auto-margin pax-form__container">
      <Col sm="5" className="no-padding-left">
        <SelectorInput
          type="text"
          name="name"
          dataTestLabel={`pax-${id}-name`}
          placeHolder={customPlaceHolder}
          defaultValue={name}
          onlyCharacters
          isValid={cehckValidation(name)}
          onBlurEvent={handlePaxName}
          readOnly={readOnly}
        />
      </Col>
      <Col sm="7" className="no padding-left">
        <SelectorInput
          type="text"
          name="surnames"
          dataTestLabel={`pax-${id}-surnames`}
          placeHolder={customPlaceHolder}
          defaultValue={surnames}
          onlyCharacters
          isValid={cehckValidation(surnames)}
          onBlurEvent={handlePaxSurname}
          readOnly={readOnly}
        />
      </Col>
    </Row>
  );
};

PaxForm.propTypes = {
  pax: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    surnames: PropTypes.string
  }).isRequired,
  readOnly: PropTypes.bool,
  hasToValidate: PropTypes.bool,
  handlePaxData: PropTypes.func
};

PaxForm.defaultProps = {
  readOnly: false,
  hasToValidate: false,
  handlePaxData: () => {}
};

export default PaxForm;
